var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1c92c7;}.cls-3{fill:#fff;}.cls-4{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1);}.cls-5{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-3);}.cls-6{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-5);}.cls-7{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-7);}.cls-8{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-9);}.cls-9{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-11);}.cls-10{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-13);}.cls-11{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-15);}.cls-12{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-17);}.cls-13{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-19);}.cls-14{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-21);}.cls-15{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-23);}.cls-16{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-25);}.cls-17{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-27);}.cls-18{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-29);}.cls-19{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-31);}.cls-20{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-33);}.cls-21{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-35);}.cls-22{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-37);}.cls-23{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-39);}.cls-24{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-41);}.cls-25{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-43);}.cls-26{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-45);}.cls-27{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-47);}.cls-28{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-49);}.cls-29{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-51);}.cls-30{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-53);}.cls-31{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-55);}.cls-32{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-57);}.cls-33{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-59);}.cls-34{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-61);}.cls-35{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-63);}.cls-36{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-65);}.cls-37{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-67);}.cls-38{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-69);}.cls-39{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1-71);}"), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(1.28 0.51) scale(0.98 1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-3",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(7.83 4.64) scale(0.93 0.97)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-5",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(4.94 -1.63)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-7",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(8.94 -1.63)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-9",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(12.94 -1.63)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-11",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(16.94 -1.63)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-13",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(20.94 -1.63)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-15",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(24.94 -1.63)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-17",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(28.94 -1.63)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-19",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(0.94 2.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-21",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(4.94 2.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-23",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(8.94 2.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-25",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(12.94 2.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-27",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(16.94 2.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-29",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(20.94 2.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-31",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(24.94 2.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-33",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(28.94 2.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-35",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(0.94 6.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-37",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(4.94 6.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-39",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(8.94 6.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-41",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(12.94 6.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-43",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(16.94 6.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-45",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(20.94 6.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-47",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(24.94 6.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-49",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(28.94 6.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-51",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(0.94 10.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-53",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(4.94 10.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-55",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(8.94 10.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-57",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(12.94 10.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-59",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(16.94 10.38)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-61",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-63",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(0 -3) scale(1 1.14)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-65",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(3)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-67",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "translate(3 -3) scale(1 1.14)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-69",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "matrix(-1, 0, 0, 1, -1, 0)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1-71",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 4,
    height: 4,
    patternTransform: "matrix(-1, 0, 0, 1.14, -1, -3)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 4,
    height: 4
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u041C\u043E\u043D\u0442\u0430\u0436\u043D\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1,
    y: 8,
    width: 44,
    height: 30
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14,8v2h7V8ZM36,8v2h7V36H3V10h7V8H1V38H45V8ZM32,8H25v2h7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "44 16.03 2 16.03 2 18.03 44 18.03 44 16.03 44 16.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 12,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 16,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 20,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 24,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 28,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 32,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 36,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 8,
    y: 24,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 12,
    y: 24,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 16,
    y: 24,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 20,
    y: 24,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 24,
    y: 24,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 28,
    y: 24,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 32,
    y: 24,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 36,
    y: 24,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 8,
    y: 28,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 12,
    y: 28,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 16,
    y: 28,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 20,
    y: 28,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 24,
    y: 28,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 28,
    y: 28,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 32,
    y: 28,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 36,
    y: 28,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 8,
    y: 32,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 12,
    y: 32,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 16,
    y: 32,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 20,
    y: 32,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 24,
    y: 32,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 23,
    cy: 13,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 22,
    y: 5,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 34,
    cy: 13,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 33,
    y: 5,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 12,
    cy: 13,
    r: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11 13 13 13 13 5 11 5 11 13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fcc9f915ac69f7dd350f5dd76cee8faf.svg";
export { ForwardRef as ReactComponent };